"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateGroup = updateGroup;
async function updateGroup(activeUserId, groupUpdatePayload) {
    const url = `/dashboard/${activeUserId}/group/${groupUpdatePayload.id}`;
    const data = new URLSearchParams();
    const integrationSettings = groupUpdatePayload.integrationSettings;
    data.append("name", groupUpdatePayload.name);
    data.append("address", groupUpdatePayload.address);
    if (groupUpdatePayload.kotAccessToken) {
        data.append("kot-access-token", groupUpdatePayload.kotAccessToken);
    }
    if (groupUpdatePayload.ccBizCompanyId !== undefined) {
        data.append("ccbizmate-id", groupUpdatePayload.ccBizCompanyId);
    }
    if (groupUpdatePayload.ccBizAPIPassword) {
        data.append("ccbizmate-api-password", groupUpdatePayload.ccBizAPIPassword);
    }
    if (groupUpdatePayload.smartHRSubdomain) {
        data.append("smarthr-subdomain", groupUpdatePayload.smartHRSubdomain);
    }
    if (groupUpdatePayload.minajinCompanyCode) {
        data.append("minajin-company-code", groupUpdatePayload.minajinCompanyCode);
    }
    if (groupUpdatePayload.selectedOem !== undefined) {
        data.append("kot-selected-oem", groupUpdatePayload.selectedOem.toString());
    }
    if (groupUpdatePayload.kotEnabled !== undefined) {
        data.append("kot-enabled", groupUpdatePayload.kotEnabled.toString());
    }
    if (groupUpdatePayload.useMFA !== undefined) {
        data.append("use-mfa", groupUpdatePayload.useMFA.toString());
    }
    if (integrationSettings?.apiRemoveExisting !== undefined) {
        data.append("api-remove-existing", integrationSettings?.apiRemoveExisting.toString());
    }
    if (integrationSettings?.enableMoneyForward !== undefined) {
        data.append("mf-enabled", integrationSettings?.enableMoneyForward.toString());
    }
    if (integrationSettings?.enableSmartHR !== undefined) {
        data.append("smart-hr-enabled", integrationSettings?.enableSmartHR.toString());
    }
    if (integrationSettings?.enableMinajin !== undefined) {
        data.append("minajin-enabled", integrationSettings?.enableMinajin.toString());
    }
    if (integrationSettings?.enablePathosLogos !== undefined) {
        data.append("pathos-logos-enabled", integrationSettings?.enablePathosLogos.toString());
    }
    if (integrationSettings?.enableXronos !== undefined) {
        data.append("xronos-enabled", integrationSettings?.enableXronos.toString());
    }
    if (integrationSettings?.enableKinjiro !== undefined) {
        data.append("kinjiro-enabled", integrationSettings?.enableKinjiro.toString());
    }
    if (integrationSettings?.enableMoneyForward && integrationSettings?.moneyForwardSyncOnly !== undefined) {
        data.append("mf-sync-only", integrationSettings?.moneyForwardSyncOnly.toString());
    }
    if (integrationSettings?.enableMoneyForward && integrationSettings?.moneyForwardIncludePunchEnabledLocations !== undefined) {
        data.append("mf-punch-enabled-locations", integrationSettings.moneyForwardIncludePunchEnabledLocations.toString());
    }
    try {
        const response = await fetch(url, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: data.toString(),
        });
        const json = await response.json();
        if (!response.ok || !json.success) {
            throw new Error("Failed to update group");
        }
        return json;
    }
    catch (err) {
        throw err;
    }
}
